import { createContext } from "react";

export const ColorModeContext = createContext({ toggleColorMode: () => {}, mode: String });
export const FormDataControlContext = createContext("formDataControl");
